import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Start } from './pipes/star.pipe';
import { DropdownTreeviewSelectComponent } from './_components/dropdown-treeview-select/dropdown-treeview-select.component';
import { TreeviewModule} from 'ngx-treeview';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NotifyAlertComponent } from './_components/notify-alert/notify-alert.component';
import {ShippingAmazonSectionComponent} from '@app/market-amazon/shipping-amazon-section/shipping-amazon-section.component';

@NgModule({
  declarations: [
    Start,
    DropdownTreeviewSelectComponent,
    NotifyAlertComponent,
    ShippingAmazonSectionComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TreeviewModule.forRoot(),
  ],
  exports: [
    Start,
    DropdownTreeviewSelectComponent,
    NotifyAlertComponent,
    ShippingAmazonSectionComponent
  ]
})
export class SharedModule { }
